import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot} from '@angular/router';
import { AuthService} from '../auth/auth.service';

@Injectable()
export class PlanExpirationGuard implements CanActivate {
    constructor(public auth: AuthService, public router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (this.auth.isPlanExpired()) {
          this.router.navigate(['/update-plan']);
          return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./client/app/core/guards/plan-expiration-guard.ts